import { FC } from "react";
import { ROUTES } from "constants/routes";
import { ForgotPassword } from "features/ForgotPassword";
import { AuthLayout } from "layouts/AuthLayout";

const ForgotPasswordPage: FC = () => (
  <AuthLayout backRoute={ROUTES.signIn}>
    <ForgotPassword />
  </AuthLayout>
);

export default ForgotPasswordPage;
